import { Link } from 'react-router-dom';
import { countByType } from '@/lib/film';

const entries = [
  {
    type: 'movie' as const,
    title: '电影',
    icon: 'ri-film-line',
    desc: '院线新片、口碑佳作与硬核类型片，一次看全。',
    tags: ['科幻', '悬疑', '剧情'],
  },
  {
    type: 'tv' as const,
    title: '电视剧',
    icon: 'ri-tv-2-line',
    desc: '热播剧集、单元短剧与高分长剧，追更不迷路。',
    tags: ['爱情', '犯罪', '历史'],
  },
];

export default function CategoryShortcut() {
  return (
    <section className="mx-auto w-full max-w-portal px-4 pt-12 md:px-6 md:pt-16">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category?type=${entry.type}`}
            className="group flex cursor-pointer items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-100/70 p-5 transition-colors duration-300 hover:border-primary-300 hover:bg-primary-50 md:p-6"
          >
            <div className="flex items-start gap-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-600 text-xl text-background-50 transition-colors group-hover:bg-primary-700">
                <i className={entry.icon} />
              </span>
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{entry.title}</h3>
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-800">
                    {countByType(entry.type)} 部
                  </span>
                </div>
                <p className="mt-1.5 max-w-xs text-sm leading-relaxed text-foreground-500">{entry.desc}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {entry.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-800"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <i className="ri-arrow-right-up-line shrink-0 text-xl text-foreground-300 transition-colors group-hover:text-primary-600" />
          </Link>
        ))}
      </div>
    </section>
  );
}